import ApiService from "@/common/api.service";
import moment from "moment";

const noData = [null, "", undefined, "null"]
const serviceLabel = (i) => {
  if (!noData.includes(i)) {
    if (i.clean_up_frequency === 'one_time') {
      if (Boolean(i.commercial)) return `One Time ${i.pricing_plan_name}`
      if (noDogsService(i)) return `One Time - ${i.pricing_plan_name || i.service_plan_name}`
      return 'One Time - Cleanup'
    } else {
      if (Boolean(i.commercial) || noDogsService(i)) {
        return i.pricing_plan_name
      } else {
        return `${i.pricing_plan_name} - ${i.service_plan_name}`
      }
    }
  } else {
    return null
  }
}
const noDogsService = (i) => {
  return !Boolean(i.commercial) &&
    !noData.includes(i) &&
    (
      (
        !noData.includes(i.pricing_plan_name) &&
        !['Regular Plan', 'Premium Plan'].includes(i.pricing_plan_name) &&
        !noData.includes(i.service_plan_name) &&
        typeof i.service_plan_name === 'string' &&
        !i.service_plan_name.includes('d-')
      ) ||
      (
        !noData.includes(i.service_plan_name) &&
        noData.includes(i.service_plan_slug)
      )
    )
}

const state = {
  residentialSchedules: [],
  loadingResidentialSchedules: false,
  selectedResidentialScheduleId: null,

  nextResidentialClenupDay: null,
  loadingNextResidentialClenupDay: false,
};

const getters = {
  residentialSchedules(state) {
    let out = state.residentialSchedules

    let showOneTimesInPast = 3
    let oneTimesInPast = out.filter(s => {
      return s.clean_up_frequency === 'one_time' &&
      !noData.includes(s.service_days) &&
      !noData.includes(s.service_days[0]) &&
      !noData.includes(s.service_days[0].start_date) &&
      moment(s.service_days[0].start_date).isBefore(moment().format('YYYY[-]MM[-]DD'))
    })
    if (oneTimesInPast.length > 0) {
      out = out.filter(i => !oneTimesInPast.some(j => j.client_location_id === i.client_location_id))
      out = [...out, ...oneTimesInPast]
    }
    if (oneTimesInPast.length > showOneTimesInPast) {
      oneTimesInPast = oneTimesInPast.sort((a, b) => moment(a.service_days[0].start_date).diff(moment(b.service_days[0].start_date)))
      oneTimesInPast = oneTimesInPast.reverse()
      oneTimesInPast = oneTimesInPast.slice(showOneTimesInPast)
      out = out.filter(i => !oneTimesInPast.some(j => j.client_location_id === i.client_location_id))
    }
    
    return out
  },
  loadingResidentialSchedules(state) {
    return state.loadingResidentialSchedules;
  },
  selectedResidentialSchedule(state, getters) {
    if(
      !noData.includes(state.selectedResidentialScheduleId) &&
      getters.residentialSchedules.some(i => i.client_location_id === state.selectedResidentialScheduleId)
    ) {
      return getters.residentialSchedules.find(i => i.client_location_id === state.selectedResidentialScheduleId)
    }
    return null
  },

  residentialUnassigned (state, getters) {
    let out = getters.residentialSchedules.filter(s => {
      return !noData.includes(s.unasigned) && Boolean(Number(s.unasigned))
    })
    return out 
  },
  isResidentialUnassigned: state => data => {
    let res = data
    let recuring_service_days = res.service_days.filter(i => i.service_type === "recurring")
    let one_time_service_days = res.service_days.filter(i => i.service_type === "one_time")

    const unassigned = (
      recuring_service_days.length === 0 && 
      !noData.includes(res.clean_up_frequency) && 
      res.clean_up_frequency !== 'one_time'
    ) ||
    (
      one_time_service_days.length === 0 &&
      (
        noData.includes(res.clean_up_frequency) ||
        res.clean_up_frequency === 'one_time'
      )
    )
    return unassigned
  },

  jobDatesForResidential (state, getters) {
    return getters.selectedResidentialSchedule ? 
          getters.selectedResidentialSchedule :
          null
  },
  nextResidentialClenupDay (state, getters) {
    return getters.selectedResidentialSchedule &&
          getters.selectedResidentialSchedule.status === 'active' &&
          getters.selectedResidentialSchedule.nextCleanup ? 
          getters.selectedResidentialSchedule.nextCleanup :
          null
  },
  loadingNextResidentialClenupDay(state) {
    return state.loadingNextResidentialClenupDay;
  },
  geoLocation(state) {
    if (
      !noData.includes(state.residentialSchedules) &&
      Array.isArray(state.residentialSchedules) &&
      !noData.includes(state.residentialSchedules[0]) &&
      !noData.includes(state.residentialSchedules[0].lat) &&
      !noData.includes(state.residentialSchedules[0].lng)
    ) {
      return {
        lat: state.residentialSchedules[0].lat,
        lng: state.residentialSchedules[0].lng
      }
    } else {
      return null
    }
  },
  showNextResidentialCleanupDayNote (state, getters) {
    return getters.nextResidentialClenupDay &&
      getters.nextResidentialClenupDay.next_cleanup &&
      getters.selectedResidentialSchedule.subscription &&
      getters.selectedResidentialSchedule.subscription.pause_subscription_start_date &&
      getters.selectedResidentialSchedule.subscription.pause_subscription_end_date &&
      moment(getters.nextResidentialClenupDay.next_cleanup, "MMM D[,]YYYY").isBetween(
        moment(getters.selectedResidentialSchedule.subscription.pause_subscription_start_date),
        moment(getters.selectedResidentialSchedule.subscription.pause_subscription_end_date),
        undefined,
        '[)'
      )
  },
  residentialSubscriptionPauseStartDate (state, getters) {
    if (
      getters.selectedResidentialSchedule &&
      getters.selectedResidentialSchedule.subscription &&
      getters.selectedResidentialSchedule.subscription.pause_subscription_start_date
    ) {
      return getters.selectedResidentialSchedule.subscription.pause_subscription_start_date
    } else {
      return null
    }
  },
  residentialSubscriptionPauseEndDate (state, getters) {
    if (
      getters.selectedResidentialSchedule &&
      getters.selectedResidentialSchedule.subscription &&
      getters.selectedResidentialSchedule.subscription.pause_subscription_end_date
    ) {
      return getters.selectedResidentialSchedule.subscription.pause_subscription_end_date
    } else {
      return null
    }
  }
}

const actions = {
  getResidentialSchedules (context, payload) {
    context.commit('setLoadingResidentialSchedules', true);
    context.commit('setResidentialSchedules', [])
    return new Promise((resolve, reject) => {
      ApiService.get("/client/details/scheduler/client_locations_for_residential_client", payload)
        .then(response => {
          let schedules = response.data.client_locations
          context.commit('setResidentialSchedules', schedules);
          context.commit('setLoadingResidentialSchedules', false);
          if(
            context.getters.residentialSchedules &&
            context.getters.residentialSchedules.length &&
            noData.includes(context.getters.selectedResidentialSchedule)
          ) {
            context.commit('setSelectedResidentialSchedule', context.getters.residentialSchedules[0])
          }
          resolve(schedules);
        })
        .catch(({response}) => {
          console.log('Residential Schedules Error');
          context.commit('setLoadingResidentialSchedules', false);
          reject(response);
        })
    })
  },
  getNextResidentialClenupDay(context, body) {
    context.commit('setLoadingNextResidentialClenupDay', true);
    context.commit('setNextResidentialClenupDay', null);
    context.dispatch('getResidentialSubscription')
    return new Promise((resolve, reject) => {
      ApiService.get("/next_cleanup_day", body)
        .then(response => {
          context.commit('setNextResidentialClenupDay', {
            client_location_id: body.client_location_id,
            next_cleanup: response.data.next_cleanup
          });
          context.commit('setLoadingNextResidentialClenupDay', false);
          resolve(response);
        })
        .catch(({response}) => {
          console.log('Next Cleanup Day Error');
          context.commit('setLoadingNextResidentialClenupDay', false);
          reject(response);
        })
    })
  },
  getResidentialSubscription(context, body) {
    return new Promise((resolve, reject) => {
      if (
        context.getters.selectedResidentialSchedule &&
        context.getters.selectedResidentialSchedule.subscription_id
      ) {
        let subscription_id = context.getters.selectedResidentialSchedule.subscription_id
        ApiService.get(`/subscription/${subscription_id}`)
          .then(response => {
            let subscription = response.data.subscription
            context.commit('setResidentialSubscription', subscription)
            resolve(response);
          })
          .catch(({response}) => {
            console.log('Residential Subscription Error');
            reject(response);
          })
      } else {
        reject()
      }
    })
  }
}

const mutations = {
  setResidentialSchedules(state, data) {
    if(Array.isArray(data)) {
      data = data.map(i => {
        let name = serviceLabel(i) 
        return { ...i, name }
      })
    }
    state.residentialSchedules = data;
  },
  setLoadingResidentialSchedules(state, status) {
    state.loadingResidentialSchedules = status;
  },
  setSelectedResidentialSchedule(state, schedule) {
    if (!noData.includes(schedule) && !noData.includes(schedule.client_location_id)) {
      state.selectedResidentialScheduleId = schedule.client_location_id;
    } else {
      state.selectedResidentialScheduleId = null
    }
  },

  setNextResidentialClenupDay(state, data) {
    if(state.selectedResidentialScheduleId) {
      let schedules = _.cloneDeep(state.residentialSchedules)
      schedules.forEach(i => {
        if (i.client_location_id === state.selectedResidentialScheduleId) {
          i.nextCleanup = data
        }
      })
      state.residentialSchedules = schedules
    }
  },
  setLoadingNextResidentialClenupDay(state, data) {
    state.loadingNextResidentialClenupDay = data;
  },

  setResidentialSubscription(state, data) {
    let schedules = _.cloneDeep(state.residentialSchedules)
    if(Array.isArray(schedules)) {
      schedules.forEach(i => {
        if (i.subscription_id === data.id) {
          i.subscription = data
          if (i.status !== data.status) {
            i.status = data.status
          }
        }
      })
      state.residentialSchedules = schedules
    }
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};